import Home from '../views/login.svelte';
import Clientes from '../views/clientes.svelte';
import Tickets from '../views/tickets.svelte';
import Katana from '../views/katana.svelte';
import Descargas from '../views/descargas.svelte';
import Perfil from '../views/perfil.svelte';
import Series from '../views/series.svelte';
import Conceptos from '../views/conceptos.svelte';

import {jwt} from '../store';
import {wrap} from 'svelte-spa-router';
import {get} from 'svelte/store';

const route = (component) => {
    return wrap(
        component,
        {page: 'general'},
        () => get(jwt) === '',
    )
};

export const routes = {
	'/': Home,
    '/clientes': wrap(
        Clientes,
        {page: 'Clientes'},
        () => {
            return get(jwt) !== ''

        },
    ),
    '/perfil': wrap(
        Perfil,
        {page: 'Perfil'},
        () => {
            return get(jwt) !== ''

        },
    ),
    '/tickets': wrap(
        Tickets,
        {page: 'Tickets'},
        () => {
            return get(jwt) !== ''

        },
    ),
    '/katana': wrap(
        Katana,
        {page: 'Katana'},
        () => {
            return get(jwt) !== ''

        },
    ),
    '/descargas': wrap(
        Descargas,
        {page: 'Descargas'},
        () => {
            return get(jwt) !== ''

        },
    ),
    '/conceptos': wrap(
        Conceptos,
        {page: 'Conceptos'},
        () => {
            return get(jwt) !== ''

        },
    ),
    '/series': wrap(
        Series,
        {page: 'Series'},
        () => {
            return get(jwt) !== ''

        },
    )
};